import PropTypes from 'prop-types';

export const checkoutSummaryProps = {
  discountSubtotal: PropTypes.string,
  discountTotal: PropTypes.string,
  giftCardAppliedTotal: PropTypes.string,
  grandTotal: PropTypes.string,
  grandTotalAfterGiftCards: PropTypes.string,
  originalTotal: PropTypes.string,
  promoCodeDiscount: PropTypes.string,
  salesTax: PropTypes.string,
  subtotal: PropTypes.string,
};

export const checkoutSummary = PropTypes.shape(checkoutSummaryProps);
